import { render, staticRenderFns } from "./ChartsPlugin.vue?vue&type=template&id=7c19f89f&scoped=true"
import script from "./ChartsPlugin.vue?vue&type=script&lang=ts"
export * from "./ChartsPlugin.vue?vue&type=script&lang=ts"
import style0 from "./ChartsPlugin.vue?vue&type=style&index=0&id=7c19f89f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19f89f",
  null
  
)

export default component.exports